import React, {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image1 from "../../../../assets/images/blog29/image1.JPG";
import image7 from "../../../../assets/images/blog29/image7.PNG";
import image27 from "../../../../assets/images/blog29/image27.png";
import image2 from "../../../../assets/images/blog29/image2(2).PNG";
import image3 from "../../../../assets/images/blog29/image3 breakevens.PNG";
import image5 from "../../../../assets/images/blog29/image5(1).PNG";
import image6 from "../../../../assets/images/blog29/image6.PNG";
import image29 from "../../../../assets/images/blog29/image29.png";
import image24 from "../../../../assets/images/blog29/image24.PNG";
import image18 from "../../../../assets/images/blog29/image18.PNG";
import image19 from "../../../../assets/images/blog29/image19.PNG";
import image12 from "../../../../assets/images/blog29/image12.PNG";
import image11 from "../../../../assets/images/blog29/image11.PNG";
import image14 from "../../../../assets/images/blog29/image14.PNG";
import image15 from "../../../../assets/images/blog29/image15.PNG";
import image16 from "../../../../assets/images/blog29/image16.PNG";
import image17 from "../../../../assets/images/blog29/image17.PNG";
import image23 from "../../../../assets/images/blog29/image23.PNG";
import image22 from "../../../../assets/images/blog29/image22.PNG";
import image21 from "../../../../assets/images/blog29/image21.PNG";
const Blog29 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – July 28th, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Tariff Triumphs, Retail Frenzy, and the Calm Before the Catalyst Storm</p>
        <p>
          Markets are drifting higher with retail in control, meme stocks in mania mode, and Trump securing back-to-back trade wins. As over 40% of the S&P reports earnings this week—including four of
          the Mag7—traders are loading up despite mounting signs of froth. Liquidity remains abundant, but sentiment and structure hint that August could get spicy fast.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Uptrend Holds, Froth Builds</p>
              <p>
                Trump’s latest deal with the EU caps a trade diplomacy streak that’s now roped in 33 countries (if you count the EU bloc). The result? Tariffs softened, U.S. investments up, and the
                path to a deficit-funded stimulus becomes more plausible.
              </p>
              <p>
                Retail continues to dominate inflows, chasing anything speculative. Hedge funds remain squeezed and underweight, while insiders are increasingly hands-off. Institutions are gradually
                dipping back in, but sentiment is still stretched.
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>SPX is in a strong uptrend y</p>
                </li>
                <li className="themesPointer">
                  <p>17 straight sessions without a 1%+ move</p>
                </li>
                <li className="themesPointer">
                  <p>VIX below 16, but signs of seasonal risk are creeping in</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image7}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image7)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image27}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image27)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The narrative still rhymes with 1998: a euphoric summer run, followed by a sideways drift into a late-year breakout. But traders must watch for sentiment extremes—especially in the
                speculative corners of the market.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Dollar Wobbles, Cuts Ahead?</p>
              <p className="highlightedText">The Fed’s Dilemma: Lagging the Curve?</p>
              <p>
                Shelter—a massive CPI weight—is now expected to drag inflation lower into Q3. The Fed, boxed in by “higher for longer” language, may be forced to play catch-up. Futures still price in
                rate cuts later this year.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Powell’s recent sit-down with Trump has fueled speculation about the Fed’s independence. Market inflation expectations (breakevens) have ticked up, pricing in a more stimulative fiscal
                path as tariff cash rolls in.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p className="highlightedText">Dollar Death Cross?</p>
              <p>
                The dollar initially rallied post-deal, but the DXY now sits precariously near a technical inflexion. Is the counter-trend rally over, or are we seeing a temporary consolidation?
                Traders are hedging for their own side.
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>DXY breaks prior trend</p>
                </li>
                <li className="themesPointer">
                  <p>Death cross forming</p>
                </li>
                <li className="themesPointer">
                  <p>Risk reversals show heavy downside skew</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image29}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image29)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Meanwhile, gold and silver are coiling. With silver pushing for leadership and gold nearing a base, metals may benefit from both falling real yields and fiat scepticism.</p>
              <div className="relatedImg">
                <img
                  src={image24}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image24)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Mania or Momentum?</p>
              <p>
                The S&P and Nasdaq continue their stealth grind higher. SPX remains in a confirmed uptrend, though breadth is narrow. Meme stocks, speculative names, and high-beta sectors are leading
                signs of a potential short-term blowoff.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image18}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image18)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image19}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image19)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>The Nasdaq 100 may be completing an ending diagonal pattern, raising reversal risk in early August. Meanwhile, leveraged players are getting torched:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Hedge funds underperform SPX</p>
                </li>
                <li className="themesPointer">
                  <p>Insider buys fading</p>
                </li>
                <li className="themesPointer">
                  <p>Short gamma squeezes accelerating</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image12}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image12)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image11}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image11)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image14}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image14)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Toxic names, penny stocks, and options mania are back—15% of NYSE trades were in 5c stocks last week. Watch for a volatility burst if positioning unwinds.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image16}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image16)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Trump Diplomacy, Meme Mania, and Disinflation Cues</p>
              <p className="highlightedText">Trade: The Certainty Markets Craved</p>
              <p>Two huge wins for Trump—Japan and the EU—locked in U.S. export pathways, lowered tariffs, and reinforced investment flows back into American manufacturing. The result:</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Tariff risk fading into a known quantity</p>
                </li>
                <li className="themesPointer">
                  <p>Retail confidence surging</p>
                </li>
                <li className="themesPointer">
                  <p>Pros are still catching up to the tape</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p className="highlightedText">Earnings: Strength Builds Into Mega Week</p>
              <p>Q2 earnings delivered again, now tracking +7.7% YoY vs +5.8% expected.</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Big tech beats (GOOGL, MSFT) driving upward revisions</p>
                </li>
                <li className="themesPointer">
                  <p>Misses punished—fundamentals still matter</p>
                </li>
                <li className="themesPointer">
                  <p>Buybacks muted in blackout, but positioning is supportive</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image23}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image23)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image22}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image22)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p className="highlightedText">Sentiment: Frothy, Frenzied, and Focused on Meme Mania</p>
              <p>Retail inflows dominated. Hedge funds squeezed, insiders were cautious, and meme stocks exploded.</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Opendoor saw a 121% single-day move, 10% of all NYSE trades</p>
                </li>
                <li className="themesPointer">
                  <p>ARK & toxic names now short-squeeze magnets</p>
                </li>
                <li className="themesPointer">
                  <p>Positioning flipping parabolic</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image14}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image14)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image15}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image15)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: FOMC, Big Tech Earnings, and Global Macro Fireworks</p>
              <p>
                This is one of the busiest macro weeks of the summer—40% of the S&P 500 reports, including META, MSFT, AAPL, and AMZN. Meanwhile, central bank decisions and labour market data roll in
                across the globe.
              </p>

              <p className="highlightedText">Monday, July 28</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>CNY Industrial Profits (YoY: -1.8%)</p>
                </li>

                <li className="themesPointer">
                  <p>GBP CBI Trades Survey</p>
                </li>
                <li className="themesPointer">
                  <p>CAD Wholesale Sales</p>
                </li>
                <li className="themesPointer">
                  <p>USD Dallas Fed Manufacturing</p>
                </li>
                <li className="themesPointer">
                  <p>Auctions: U.S. 3M & 6M Bills, 2Y & 5Y Notes</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, July 29</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>GBP BRC Shop Prices, M4 Money Supply</p>
                </li>
                <li className="themesPointer">
                  <p>SP GDP & Retail Sales</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. JOLTS, CB Consumer Confidence, Retail Inventories</p>
                </li>
                <li className="themesPointer">
                  <p>Major Earnings: Visa, Merck, Boeing, Spotify, Starbucks, UPS, Booking</p>
                </li>
                <li className="themesPointer">
                  <p>Auctions: U.S. 7Y Note</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, July 30</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>AUD CPI, EZ GDP, FR GDP</p>
                </li>
                <li className="themesPointer">
                  <p>USD ADP Payrolls, Q2 GDP, Pending Home Sales</p>
                </li>
                <li className="themesPointer">
                  <p>CAD Rate Decision</p>
                </li>
                <li className="themesPointer">
                  <p>FOMC Rate Decision + Treasury Q3 Funding Plan</p>
                </li>
                <li className="themesPointer">
                  <p>Major Earnings: META, MSFT, Qualcomm, Ford, Robinhood, Mercedes, HSBC</p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, July 31</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>BOJ Rate Decision</p>
                </li>
                <li className="themesPointer">
                  <p>EZ CPI Flash, US PCE, Jobless Claims</p>
                </li>
                <li className="themesPointer">
                  <p>JPY Retail Sales, CHF Retail Sales</p>
                </li>
                <li className="themesPointer">
                  <p>Major Earnings: AAPL, AMZN, Mastercard, Reddit, Coinbase, Riot</p>
                </li>
              </ul>

              <p className="highlightedText">Friday, August 1</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Global Final PMIs (July), U.S. NFP, ISM Manufacturing</p>
                </li>
                <li className="themesPointer">
                  <p>EZ CPI, CAD GDP</p>
                </li>
                <li className="themesPointer">
                  <p>Major Earnings: ExxonMobil, Chevron, Regeneron, T. Rowe Price</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Melt-Up On, but Watch for Triggers</p>
              <p>Markets are still riding the melt-up wave, but sentiment has flipped euphoric and structural risks are mounting:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Meme stocks in blow-off mode</p>
                </li>
                <li className="themesPointer">
                  <p>Hedge fund underperformance is fueling squeezes</p>
                </li>
                <li className="themesPointer">
                  <p>The dollar is sitting on a technical cliff</p>
                </li>
                <li className="themesPointer">
                  <p>Fed boxed in ahead of potential disinflation shock</p>
                </li>
              </ul>
              <p>Still, with Trump neutralising tariff chaos and earnings holding strong, there's little near-term reason to fade strength—unless the data or Fed disappoint.</p>
              <p className="highlightedBoldText">Our stance: </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Stay long high-conviction tech & large-cap quality</p>
                </li>
                <li className="themesPointer">
                  <p>Use August volatility to scale into gold and silver exposure</p>
                </li>
                <li className="themesPointer">
                  <p>Watch FOMC, NFP, and tech earnings for reversal signals</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image27}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image27)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1HrPfSTz7eLK26P7EEzV4TpaYbb2MzYnnOCTBvkFY460/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog29;
